import { goodlucky, apolloConfigGame } from '@/services/api';

const GameList = {
  namespace: 'gameList',
  state: {
    gameList: [],
    link: {}
  },
  reducers: {
    updateList(state, { payload }) {
      return {
        ...state,
        gameList: payload
      };
    },
    updateLink(state, { payload }) {
      console.log(payload, 'reabhdcbhj')
      return {
        ...state,
        link: payload,
      };
    }
  },
  effects: {
    *apolloConfig({payload}, { call, put }) {
      const res = yield call(apolloConfigGame, payload);
      yield put({
        type: 'updateLink',
        payload: res?.data || [],
      });
      return res;
    },
    *luckyList({ payload }, { call, put }) {
      const { data } = yield call(goodlucky, payload);
      yield put({
        type: 'updateList',
        payload: data || []
      });
      return data;
    }
  }
};

export default GameList;
